import { castToNumberData } from "./transformData";

const getUniqueValues = (arr, key) => {
    return [...new Set(arr.map((item) => item[key]))];
};

// transform

export const treeTransformDataEchart = (
    data,
    boxKey,
    subBoxKey,
    valueKey,
    toolTipKeys,
    rootName = "Disk Usage"
) => {
    // console.log(data, boxKey, subBoxKey, valueKey, toolTipKeys);

    if (!data || !valueKey || !boxKey) return null;

    const valueResponseKey = valueKey.responseKey;
    const tooltipKeys = toolTipKeys?.map((t) => t.responseKey) || [];
    const allKeysToCast = [valueResponseKey, ...tooltipKeys];

    // Convert numeric fields
    const formattedData = castToNumberData(data, allKeysToCast);

    const tree = {
        name: rootName,
        children: [],
    };

    const uniqueBoxGroups = getUniqueValues(formattedData, boxKey);

    uniqueBoxGroups.forEach((boxValue) => {
        // console.log(boxValue);

        const children = formattedData
            .filter((item) => item[boxKey] === boxValue)
            .map((item) => {
                // console.log(item);

                const childName = subBoxKey ? item[subBoxKey] : boxValue;
                // console.log(childName);

                const value = item[valueResponseKey];

                return {
                    name: childName,
                    value,
                };
            });

        tree.children.push({
            name: boxValue,
            children,
        });
    });

    return tree;
};
